import { Component,OnInit, Inject, ViewChild, ElementRef} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DOCUMENT } from "@angular/platform-browser";
import { FileUpload } from "../../../shared/app/classes/file-upload";
import { HttpClientModule } from "@angular/common/http";
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PayeeSubmission, PayeePos, PayeeAttachment, PayeeAttachmentDetail, SubmissionSubtagMapping} from '../../../shared/sdk/models';
import { PayeeApi, StorageApi ,PayeeSubmissionApi } from '../../../shared/sdk/services';
import { FormPage } from '../../../shared/app/classes/form-page'
import { GlobalEventsManager } from '../../../events-manager.component';
import { SubmissionDetailService } from "../../../shared/app/services/";
import { LoopBackConfig } from "../../../shared/sdk/lb.config";
import { CONSTANT } from '../../../shared/app/constants'

@Component({
  selector: 'pos-offer-letter',
  templateUrl: 'pos-offer-letter.component.html',
  providers: [
    { provide: 'Window',  useValue: window }
  ],
  styleUrls: ['../../application.css']
})



export class POSOfferLetterComponent extends FileUpload implements OnInit {
  @ViewChild('oldownload') oldownload: ElementRef;
  @ViewChild('optOutdownload') optOutdownload: ElementRef;
  
  CONSTANT = CONSTANT;
  TAG = "POSOfferLetterComponent";
  new:boolean = false;
  src:any;
  mobileSrc:any;
  optOutSrc:any;
  file_name: any;
  isMobile: boolean;
  randomFileName: string;
  detail: PayeeAttachmentDetail;
  pos: PayeePos;
  submissionId: number;

  cardsPosSignedLoPayeeAttachedFileExists: boolean = false;
  cardsPosSignedLgPayeeAttachedFileExists: boolean = false;
  cardsPosSignedPaymentSlipPayeeAttachedFileExists: boolean = false;
  cardsPosSignedDeclarationFormPayeeAttachedFileExists: boolean = false;
  posSignedLoPayeeAttachedFileName: string;
  posSignedLgPayeeAttachedFileName: string;
  posSignedPaymentSlipPayeeAttachedFileName: string;
  posSignedDeclarationFormPayeeAttachedFileName: string;

  isPublicOrPrivate:boolean = false;

  valid: boolean = true;


  constructor(
    protected payeeApi: PayeeApi,
    private payeeSubmissionApi: PayeeSubmissionApi,
    private router: Router,
    protected storageApi: StorageApi,
    protected eventManager: GlobalEventsManager,
    private submissionDetailService: SubmissionDetailService,
    private sanitizer:DomSanitizer,
    private http: HttpClientModule,
    @Inject(DOCUMENT) private document: Document,
  ) { 
    super(payeeApi, storageApi, eventManager);
    
  }

  attachment: PayeeAttachment; 

  adminChecklist;
  adminChecklistRemark;

  loSubTags: Array<SubmissionSubtagMapping> = null;

  checklistStatuses = ["Web Checklist Completed","Merchant to review","Pending Website Checklist Approval"];

  
  // Initialisation
  async ngOnInit() { 
    // this.setUpFileUploader('cards_ecom_signed_lo_payee_attached');
    // console.log(this.TAG + "getOfferLetter: ");
    this.randomFileName = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)+".pdf";
    if (window.screen.width < 1200) { // 768px portrait
      this.isMobile = true;
    }
    
    this.getOfferLetter().subscribe(
      (res : PayeeSubmission) => {
        this.eventsManager.loaded(true);
        console.log(this.TAG + "res: ");
        console.log(res);

        this.submissionId = res.id;
        this.setUpFileUploader(null,this.submissionId);

        console.log(this.TAG + "submissionId: ");
        console.log(this.submissionId);

        //check is public or private entity
        if (res['payee'] && res['payee']['details']) {
          if(res.payee.details.business_entity == "Public Listed (Berhad)" || res.payee.details.business_entity == "Private Limited (Sendirian Berhad)") 
            this.isPublicOrPrivate = true;
            
        }

        //check is opt in or out
        if (res['payee'] && res['payee']['pos']) {
          this.pos = res.payee.pos;

          console.log({pos: this.pos})
          console.log({opt_in: this.pos.opt_in})
        }

        // console.log({isPublicOrPrivate: this.isPublicOrPrivate});

        this.documentsSetUp();
        this.attachment = res.attachments[0];
        if (res.submission_subtags) {
          this.loSubTags = res.submission_subtags.filter(
            (subtag:SubmissionSubtagMapping) => (subtag.subtag_id == 4|| subtag.subtag_id == 5)
          );
          console.log(this.TAG + "loSubTags: ");
          console.log(this.loSubTags);
        }
        
        if (this.attachment.hasOwnProperty('detail')) {
          this.detail = this.attachment.detail;
        }
        else{
          this.detail = null
        }

        if (!this.detail) {
          this.detail = new PayeeAttachmentDetail;
          console.log("no detail so create one:");
          this.new = true;
          console.log( this.detail);
        }
        this.file_name = this.attachment.file_name;
        // this.src = this.getTrustedURL(LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/" + this.payeeApi.getCurrentId() + "/download/" + this.attachment.file_name + "?access_token=" + this.payeeApi.getCurrentToken().id);
        // this.optOutSrc = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/doc/download/Merchants_OptOut_Form.pdf" + "?access_token=" + this.payeeApi.getCurrentToken().id;
        this.optOutSrc = "assets/form/Merchants_OptOut_Form.pdf"; 
        this.mobileSrc = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/" + this.payeeApi.getCurrentId() + "/download/" + this.attachment.file_name + "?access_token=" + this.payeeApi.getCurrentToken().id;
      },
      err => {
        this.eventsManager.loaded(true);
        console.log(err)
        this.router.navigate(['/dashboard']);
      }
    );

  }

  getOfferLetter(){
    let filter = {
      include:[
        {
          relation:"attachments",
          scope:{
            where: {
              "or":[
                {
                  'type': "cards_pos_lo_admin",
                  'isDeleted': false
                },
              ]
            },
            include:"detail",
            order: 'created_at ASC',
            limit: 1
          }
          
        },
        {
          relation:"submission_subtags",
          scope:{
            where: {
              'deleted_at': null
            }
          }
          
        },
        {
          relation:"payee",
          scope:{
            include: [
            "details",
            "pos"]
          }
          
        },
      ]
      
    };

    return this.payeeSubmissionApi.findById(this.submissionDetailService.getCurrentSubmissionId(),filter);
  }

  documentsSetUp() {
    this.getFileDetails('cards_pos_signed_lo_payee_attached').subscribe(
      res => {
        if (res.length > 0) {
          this.cardsPosSignedLoPayeeAttachedFileExists = true;
          this.posSignedLoPayeeAttachedFileName = res[0].file_name;
        } else {
          this.cardsPosSignedLoPayeeAttachedFileExists = false;
        }
      }
    );

    this.getFileDetails('cards_pos_signed_lg_payee_attached').subscribe(
      res => {
        if (res.length > 0) {
          this.cardsPosSignedLgPayeeAttachedFileExists = true;
          this.posSignedLgPayeeAttachedFileName = res[0].file_name;
        } else {
          this.cardsPosSignedLgPayeeAttachedFileExists = false;
        }
      }
    );

    this.getFileDetails('cards_pos_signed_payment_slip_payee_attached').subscribe(
      res => {
        if (res.length > 0) {
          this.cardsPosSignedPaymentSlipPayeeAttachedFileExists = true;
          this.posSignedPaymentSlipPayeeAttachedFileName = res[0].file_name;
        } else {
          this.cardsPosSignedPaymentSlipPayeeAttachedFileExists = false;
        }
      }
    );

    this.getFileDetails('cards_pos_signed_opt_out_declaration_form_payee_attached').subscribe(
      res => {
        if (res.length > 0) {
          this.cardsPosSignedDeclarationFormPayeeAttachedFileExists = true;
          this.posSignedDeclarationFormPayeeAttachedFileName = res[0].file_name;
        } else {
          this.cardsPosSignedDeclarationFormPayeeAttachedFileExists = false;
        }
      }
    );
    
  }

  createNewOfferLetterDetail(){

    return this.payeeApi.createAttachmentsDetail(this.attachment.payee_id,this.attachment.id,this.detail);
  }

  updateOfferLetterDetail(){

    return this.payeeApi.updateAttachmentsDetail(this.attachment.payee_id,this.attachment.id,this.detail);
  }


  updatePosOpt(){

    return this.payeeApi.updatePos(this.attachment.payee_id,this.pos);
  }

  getTrustedURL(url){
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }


  populateFormData() {
    this.eventsManager.loaded(true);
    // this.payeeApi.getCmoWebChecklist(this.payeeApi.getCurrentId(), {
    //   // where: {'merchant_to_review': 1},
    //   order:'created_at DESC',
    //   include:{
    //     "relation": "adminChecklist",
    //     "scope": {
    //         "include": ["remarks"]
    //   }
    // }}).subscribe(
    //   checklists => {
    //     console.log(checklists);
    //     if (checklists.length == 0) {
    //       this.details.payee_id = this.payeeApi.getCurrentId();
    //     } else {
    //         this.details = checklists[0];
    //         this.adminChecklist = checklists[0].adminChecklist;
    //         this.adminChecklistRemark = checklists[0].adminChecklist.remarks;
    //     }
    //     this.eventsManager.loaded(true);
    //   },
    //   err => {

    //     console.log(err);
    //     this.eventsManager.logout(true);
    //     this.eventsManager.showPopUp("Your session has expired. Please login.");
    //     this.eventsManager.loaded(true);
    //   }
    // );
  }

  addEventListeners() {}

  
  submit(submit?: boolean) {

    // Send to temp storage
    let promises =[];
    let that = this;

    this.valid = (this.detail.acceptance != null)? true: false;
    console.log(this.valid);
    this.valid = ((this.detail.acceptance == false && this.detail.reason!= null) || (this.detail.acceptance == true)) ? true: false;
    console.log(this.valid);


    this.validateDocs();
    this.valid = this.docsValid && this.valid;
    
    // this.detail.submission
    console.log(this.TAG+":this.detail");    
    console.log(this.detail);

    console.log(this.TAG+":this.pos");    
    console.log(this.pos);



    if (this.valid) {
      console.log(this.TAG+":submit");
      //check whether acceptance is no then delete the attached docs
      if (!this.detail.acceptance) {
        this.deleteDocs()
      }
      
      if (this.detail.acceptance) {
        this.detail.reason = null;
      }

      if (this.new) {
        this.createNewOfferLetterDetail().subscribe(
          (createNewOfferLetterDetailRes) => {
            console.log({createNewOfferLetterDetailRes});
            //update Pos
            this.updatePosOpt().subscribe(
              (updatePosOptRes) => {
                console.log({updatePosOptRes});
                this.eventsManager.showPopUp("You have successfully submitted.");
                this.router.navigate(['/dashboard']);
              },
              updatePosOptErr => {
                console.log({updatePosOptErr});
                this.eventsManager.showPopUp("Unable to submit. Please try again later");
              }
            );
            // this.eventsManager.showPopUp("Submitted.");
            // this.router.navigate(['/dashboard']);
          },
          createNewOfferLetterDetailErr => {
            console.log({createNewOfferLetterDetailErr});
            this.eventsManager.showPopUp("Unable to submit. Please try again later");
          }
        );
      }
      else{
        this.updateOfferLetterDetail().subscribe(
          (updateOfferLetterDetaiLRes) => {
            console.log({updateOfferLetterDetaiLRes});
            //update Pos
            this.updatePosOpt().subscribe(
              (updatePosOptRes) => {
                console.log({updatePosOptRes});
                this.eventsManager.showPopUp("You have successfully submitted.");
                this.router.navigate(['/dashboard']);
              },
              updatePosOptErr => {
                console.log({updatePosOptErr});
                this.eventsManager.showPopUp("Unable to submit. Please try again later");
              }
            );
            // this.eventsManager.showPopUp("Updated.");
            // this.router.navigate(['/dashboard']);
          },
          updateOfferLetterDetaiLErr => {
            console.log({updateOfferLetterDetaiLErr});
            this.eventsManager.showPopUp("Unable to submit. Please try again later");
          }
        );
      }

      

    }
   
   
  }

  downloadFile(){
    this.oldownload.nativeElement.click();
    // var win = open(this.mobileSrc,'windowName','height=300,width=300');
    // win.document.write("");
    // window.open(this.mobileSrc);

    // this.download(this.file_name);
    // let url=this.mobileSrc;
    // this.http.get(url).map(
    //     (res) => {
    //         console.log(res);
    //         return new Blob([res.blob()], { type: 'application/pdf' })
    //     })
  }

  downloadOptOutFile(){
    this.optOutdownload.nativeElement.click();
  }
  

  validateDocs() {

    this.docsValid = true;

    if (this.detail.acceptance) {
      if (!this.cardsPosSignedLoPayeeAttachedFileExists ) {
        this.docsValid = false;
      }
      if (this.isPublicOrPrivate && !this.cardsPosSignedLgPayeeAttachedFileExists ) {
        this.docsValid = false;
      }
      // if (!this.cardsEcomSignedPaymentSlipPayeeAttachedFileExists ) {
      //   this.docsValid = false;
      // }
      if (!this.pos.opt_in && !this.cardsPosSignedDeclarationFormPayeeAttachedFileExists ) {
        this.docsValid = false;
      }
    }

  }

  // File manipulation methods

  updateDocStatus(name: string, fileName?: string) {

    // this.cardsEcomSignedLoPayeeAttachedFileExists = true;
    // this.fileName = fileName;
    switch(name) {
      case 'cards_pos_signed_lo_payee_attached':
        this.cardsPosSignedLoPayeeAttachedFileExists = true
        if (fileName) {
          this.posSignedLoPayeeAttachedFileName = fileName;
        }
        break;

      case 'cards_pos_signed_lg_payee_attached':
        this.cardsPosSignedLgPayeeAttachedFileExists = true
        if (fileName) {
          this.posSignedLgPayeeAttachedFileName = fileName;
        }
        break;
      case 'cards_pos_signed_payment_slip_payee_attached':
        this.cardsPosSignedPaymentSlipPayeeAttachedFileExists = true
        if (fileName) {
          this.posSignedPaymentSlipPayeeAttachedFileName = fileName;
        }
        break;

      case 'cards_pos_signed_opt_out_declaration_form_payee_attached':
        this.cardsPosSignedDeclarationFormPayeeAttachedFileExists = true
        if (fileName) {
          this.posSignedDeclarationFormPayeeAttachedFileName = fileName;
        }
        break;
    }
  }

  deleteDocs() {
    if ((!this.cardsPosSignedLoPayeeAttachedFileExists && this.posSignedLoPayeeAttachedFileName != null) || !this.detail.acceptance) {
      this.deleteDoc('cards_pos_signed_lo_payee_attached');
    }

    if ((!this.cardsPosSignedLgPayeeAttachedFileExists && this.posSignedLgPayeeAttachedFileName != null) || !this.detail.acceptance) {
      this.deleteDoc('cards_pos_signed_lg_payee_attached');
    }

    if ((!this.cardsPosSignedPaymentSlipPayeeAttachedFileExists && this.posSignedPaymentSlipPayeeAttachedFileName != null) || !this.detail.acceptance) {
      this.deleteDoc('cards_pos_signed_payment_slip_payee_attached');
    }

    if ((!this.cardsPosSignedDeclarationFormPayeeAttachedFileExists && this.posSignedDeclarationFormPayeeAttachedFileName != null) || this.pos.opt_in) {
      this.deleteDoc('cards_pos_signed_opt_out_declaration_form_payee_attached');
    }

  }


  // Scrolling
  scrollToTop() {
    window.scroll(0, 0);
    document.body.getElementsByClassName('scroll_checklist')[0].scrollTop = 0;
  }

  scrollToSave() {
    document.body.getElementsByClassName('scroll_checklist')[0].scrollTop = document.getElementById('save_checklist').offsetTop;
  }

}
